module.exports = __webpack_public_path__ + "static/media/ico-predefinido.da9986ac.svg";